import Hero from "../components/Hero";
import Categories from "../components/Categories";

export default function Home() {
    return (
        <>
            <Hero />
            <Categories />
        </>
    );
}
